import React from "react";
import { useSelector, useDispatch, connect } from "react-redux";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Box, Card, CardContent, CardHeader, Container, Grid, LinearProgress, FormControl, Select,
        Table, TableBody, TableContainer, TableCell, TableHead, TableRow, Typography, MenuItem} from "@material-ui/core";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import ArrowUpward from "@material-ui/icons/ArrowUpward";

import Header from "components/Headers/Header.js";
import { Popover,Whisper, Dropdown, Divider, Pagination, Checkbox, IconButton, Panel,
  Tag, InputGroup, Input, Notification, toaster, Col, Button} from 'rsuite';
import componentStyles from "assets/theme/views/admin/dashboard.js";
import { updateVersion } from '../../actions/setting';

const useStyles = makeStyles(componentStyles);

function Setting({updateVersion}) {
  const classes = useStyles();
  const theme = useTheme();
  const data = useSelector(state => state.setting);
  const [appstoreV, setAppstoreV] = React.useState('');
  React.useEffect(()=>{
    if(data.length != 0){
        const version = data.filter(item => item.type == 'version');
        if(version.length != 0) {setAppstoreV(version[0].value);}
    }
  },[data]);
  const saveVersion = () => {
    updateVersion(appstoreV).then(value => {
      if(value){
        toaster.push(<Notification type={'success'} header={'Success'} duration={3000} closable>
          You updated app version successfully.</Notification>, {
          placement: 'bottomEnd'
        });
      }else{
        toaster.push(<Notification type={'error'} header={'Error'} duration={3000} closable>
          Unfortunately, there is some issues.</Notification>, {
          placement: 'bottomEnd'
        });
      }
    })
  }
  const onChangeV = (value) => {
      setAppstoreV(value);
  }
  return (
    <>
      {/* Page content */}
      <Container maxWidth={false} component={Box} marginTop="100px" 
      classes={{ root: classes.containerRoot }}>
        <Grid container>
          <Grid item xs={24}  sm={12} md={8} component={Box} marginBottom="3rem!important" classes={{ root: classes.gridItemRoot }} >
            <Panel header="Settings for Chabbo" bordered bodyFill>
              <Panel header="Appstore Version" bordered>
                <div style={{display:'flex'}}>
                  <div style={{width: "50%"}}>
                    <Input value={appstoreV} onChange={onChangeV}/>
                  </div>
                  <div style={{width: "30%",marginLeft: "20px"}}>
                   <Button color="green" appearance="ghost" style={{marginTop: "0px"}} onClick={saveVersion}>
                     Update
                    </Button>
                  </div>
                </div>
              </Panel>
            </Panel>
          </Grid>
        </Grid>

      </Container>
    </>
  );
}

export default connect(null, { updateVersion })(Setting);
